import { Routes, RouterModule } from '@angular/router';
import { CategoryBlockList } from './categoryblock.list';
import { CategoryBlockDetailFrm } from './categoryblock.frm';

export const routes: Routes = [
    { path: 'page/categoryblocklist', component: CategoryBlockList },
    {
        path: 'categoryblockedit/:id/:dmy',
        component: CategoryBlockDetailFrm,
        data: { shouldReuseRoute: false },
    },
    { path: '', redirectTo: 'page/categoryblocklist', pathMatch: 'full' },
    {
        path: 'page/categoryblock',
        redirectTo: 'page/categoryblocklist',
        pathMatch: 'full',
    },
];

export const CATEGORYBLOCK_ROUTER_PROVIDERS = RouterModule.forRoot(routes);
